import { AuditTrailActions } from 'utils/auditTrailActions';
import IdListDTO from '../IdListDTO';

export enum WidgetTenantRiskChangesPeriods {
  Last2Days = 0,
  LastWeek = 1,
  LastMonth = 2,
  LastQuarter = 3,
  LastYear = 4,
  Last3Years = 5,
}

export class Widget67DTO {
  tenants: IdListDTO;

  actions: AuditTrailActions[];

  results?: Widget67ResultDTO[];

  constructor() {
    this.tenants = new IdListDTO([]);
    this.actions = [];
  }
}

export class Widget67ResultDTO {
  tenantId: string;

  data: { [K in keyof WidgetTenantRiskChangesPeriods]?: number[] };

  constructor() {
    this.tenantId = '';
    this.data = {};
  }
}
